import { DeletionBlockerGroup } from "@common/components/deleteBlockedDialog/DeleteBlockedDialog.types.ts";

export enum LegalEntityDeletionBlockerType {
    Asset = 1,
    ProcessingActivity = 2,
    Contract = 3,
    SubContractorOf = 4,
    AuditSender = 5,
    PublicInternalAssessmentTemplate = 6,
    InternalAssessment = 7,
    AuditGroup = 8,
    AnnualWheelActivity = 9,
    Task = 10,
    DocumentAccess = 11,
    InternalAssessmentAssignee = 12,
    InternalAssessmentGroup = 13,
    Process = 14,
}

export interface LegalEntityDeletionResult {
    isDeleted: boolean;
    name: string;
    blockers: Array<DeletionBlockerGroup>;
}
